export default "__VITE_ASSET__DfiJsNHx__"